<template>
  <SplitViewTemplate
    :screenConfig="data"
    :backButtonRoute="'/settings/intake'"
    :dataModel="formModel"
    :formConfig="setFormConfig"
    :setLoading="setLoading"
    :validationSummary="validationSummary"
    :ref="'grower-regions'"
    :defaultUserSettings="false" />
</template>
<script>
import { FeatureStorage } from "@/_services/storage";
import SplitViewTemplate from "../../../templates/split-view";
import RouteMixin from "@/_mixins/route.mixin";
export default {
  mixins: [RouteMixin],
  components: {
    SplitViewTemplate,
  },
  data() {
    return {
      setLoading: false,
      validationSummary: [],
      formModel: {
        GrowerRegionCode: null,
        GrowerRegionName: null,
        Inactive: false,
        ChangedBy: "",
        CreatedBy: "",
        DateChanged: "",
        DateCreated: "",
      },
      data: {
        title: "Grower Regions",
        pageRoute: "/grower-regions",
        saveEndPoint: "AlmondcoGrowerRegions",
        updateEndPoint: "AlmondcoGrowerRegions",
        updateKeyField: "GrowerRegionCode",
        updateKeyFieldType: "String",
        recordEndPoint: "AlmondcoGrowerRegions",
        exportFileName: "Grower Regions List",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "AlmondcoGrowerRegions",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
              sort: [{ selector: "GrowerRegionName", desc: false }],
            },
            rowSelect: {
              view: this,
              page: "grower-regions",
              mode: "review",
              idProperty: "GrowerRegionCode",
              idMode: "String",
              rowSelectCallBack: () => {
                this.beforeInit();
              },
            },
          },

          toolbar: {
            search: true,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/grower-regions/create",
                clickAction: () => {
                  this.goToCreateGrowerRegion();
                },
                buttonLocation: "left",
                visible: FeatureStorage.checkPermission(
                  "AlmondcoGrowerRegions",
                  "create"
                ),
              },
            ],
          },
          columns: [
            {
              screenField: "GrowerRegionCode",
              dataField: "GrowerRegionName",
              label: "Grower Region",
              allowHiding: false,
              sortIndex: 0,
              sortOrder: "asc",
              cellTemplate: "Record",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "GrowerRegionName",
                  },
                ],
                secondary: [
                  {
                    dataField: "GrowerRegionCode",
                  },
                ],
              },
            },
            {
              screenField: "GrowerRegionCode",
              dataField: "GrowerRegionCode",
              label: "Region",
              visible: false,
              showInColumnChooser: true,
            },
            {
              screenField: "GrowerRegionName",
              dataField: "GrowerRegionName",
              label: "Description",
              visible: false,
              showInColumnChooser: true,
            },
            {
              screenField: "Status",
              width: "auto",
              filterIndex: 0,
            },
          ],
          valueChangedEventListners: [],
        },
      },
      updatedDefaultRecordId: undefined,
      recordEditable: true,
    };
  },
  computed: {
    setFormConfig() {
      const form = {
        headerToolbar: {
          closeSplit: true,
          save: this.setSaveOption,
          audit: true,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
              ],
            },
          ],
          toolbarFormItems: [
            {
              screenField: "Inactive",
              editorType: "dxSwitch",
              editorOptions: {
                readOnly: false,
              },
              cssClass: "toolbar-customer-label",
            },
          ],
          toolbarFormLocation: "after",
          editCallBack: () => {
            this.beforeInit();
          },
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                dataField: "GrowerRegionCode",
                editorType: "dxTextBox",
                editorOptions: {
                  min: 0,
                  tabIndex: 1,
                  maxLength: 10,
                },
                required: true,
                isPrimaryKeyField: true,
                label: { text: "Region" },
                visible: true,
                allowUpdate: this.baseView.mode == "create" ? true : false,
              },
              {
                dataField: "GrowerRegionName",
                editorType: "dxTextBox",
                editorOptions: {
                  min: 0,
                  tabIndex: 2,
                  maxLength: 50,
                },
                required: true,
                label: { text: "Description" },
                visible: true,
                allowUpdate: this.recordEditable,
              },
            ],
          },
        ],
        overWritePayload: this.overWritePayload,
      };

      return form;
    },
    setSaveOption() {
      return FeatureStorage.checkPermission(
        this.$route.meta.applicationFeatureCode,
        this.baseView.mode == "create" ? "create" : "edit"
      );
    },
  },
  methods: {
    goToCreateGrowerRegion() {
      this.$router
        .push({
          path: `/grower-regions/create`,
        })
        .then(() => {
          this.recordEditable = true;
        });
    },
    beforeInit() {
      this.recordEditable = true;
    },
    overWritePayload(payload) {
      return payload;
    },
  },
  created() {
    this.beforeInit();
  },
};
</script>
